export default __webpack_public_path__ + "static/media/gel_logo_wechat.d3aa6d6f.png";